import { Component, EventEmitter, OnInit, Output } from '@angular/core';
import { ActivatedRoute } from '@angular/router';
import { TranslateService } from '@ngx-translate/core';
import { SelectItem } from 'primeng/api';

@Component({
  selector: 'app-language',
  templateUrl: './language.component.html',
  styleUrls: ['./language.component.scss']
})
export class LanguageComponent implements OnInit {
  langs: SelectItem[];
  selectedLang: any;
  flagEg: string = 'assets/layout/images/eg.png';
  flagEn: string = 'assets/layout/images/us.png';
  @Output() selectedLanguageCodeEvent = new EventEmitter<string>();
  constructor(private activatedRoute: ActivatedRoute,private translate: TranslateService) {
    this.activatedRoute.queryParams.subscribe(params => {
      let result = params['Lang'] || params['lang'];
      if(result == undefined || result == ''){
        let selectedLanguageCode = localStorage.getItem('lang');
        if(selectedLanguageCode ==  null || selectedLanguageCode == ''){
          this.selectedLang = 'en';
        }else{
          this.selectedLang = selectedLanguageCode;
        }
      }
      else{
        localStorage.setItem('lang', result.toLowerCase());
        this.selectedLang = result.toLowerCase();
      }
    });
    this.langs = [
      { label: "English", value: "en"},
      { label: "العربيه", value: "ar" }
    ];
  }

  ngOnInit(): void {
    this.selectedLanguageCodeEvent.emit(this.selectedLang);
  }
  changeLang(lang: any){
    localStorage.setItem('lang',lang.value);
    window.location.href = window.location.origin + window.location.pathname+"?lang="+lang.value;
  }
}
